module.exports = __webpack_public_path__ + "img/EX3_memory_old.bccca0b6.jpg";